module.exports = __webpack_public_path__ + "media/images/icons/v2/arrow-narrow-left-1b7fc1f1dcd86039e0935e1af3c8199e.svg";